module.exports = __webpack_public_path__ + "static/img/Metricas.e53c4694.png";